<template>
  <div class="w-full sm:max-w-xl self-center flex flex-1 flex-col items-center">
    <h3 class="font-bold my-3 sm:text-2xl">{{ $t('homePage.confirm_delete') }}</h3>
    <img
      class="mt-auto sm:w-3/5"
      src="../../../assets/common/logout-confirmation.svg"
      :alt="$t('homePage.confirm_delete')"
    />
    <div class="w-full flex mt-auto mb-5 justify-around">
      <c-button width="40%" secondary class="my-3" @click="$emit('confirm')">
        <span>{{ $t('homePage.logout') }}</span>
      </c-button>
      <c-button width="40%" class="my-3" @click="$emit('cancel')">
        <span>{{ $t('homePage.cancel_delete') }}</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'LogoutConfirmation',
  components: {
    CButton,
  },
};
</script>
